import type { SavingSettingsDetailsCountryConfig } from './SavingSettingsDetailsConfig';

export const settingsDetails: SavingSettingsDetailsCountryConfig = {
    averageSavings: {
        displayAccountOwner: true,
        displaySpacedBBAN: true,
    },
    termDeposit: {
        displayAccountOwner: true,
        displaySpacedBBAN: true,
    },
};
